module.exports = __webpack_public_path__ + "static/media/Spectre.cfd5e92d.png";